import * as Api from '@/api';
import { _restApiDataFormatting, _searchFunc, _setSortParam } from '@/utils/_function.js';
import Datepicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import selectVocabulary from '@/utils/select_vocabulary';
import { TABLE_ITEMS_AMOUNT } from '@/utils/constants';
import { resetData } from '@/utils/_function';

const getData = function(param) {
  return Api.getStatementsList(param)
    .then((response) => {
      if (response) {
        return response;
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

const filterDataResult = _searchFunc(getData);

const filterData = async function() {
  try {
    this.statementsList = await filterDataResult(this.search, this.sort);
    this.page = 2;
    this.infiniteId += 1;
    this.showSortResetBtn = !!this.sortBy;
  } catch (error) {
    if (error) {
      this.$rollbar.warning(error);
    }
    this.$toastr('error', this.$t('commonMessage.requestError'), 'Ошибка');
  }
};

export default {
  name: 'Statements',
  data() {
    return {
      ru: ru,
      page: 1,
      statementsList: [],
      sort: [],
      showSortResetBtn: false,
      sortBy: null,
      search: {},
      fields: [
        {
          key: 'createdAt',
          label: 'Дата подачи',
          sortable: true
        },
        {
          key: 'number',
          label: 'Номер заявления',
          sortable: true
        },
        {
          key: 'filer',
          label: 'Заявитель',
          sortable: true
        },
        {
          key: 'content',
          label: 'Контент',
          sortable: true
        },
        {
          key: 'claimLinks',
          label: 'Кол-во URL',
          sortable: true
        },
        {
          key: 'state',
          label: 'Статус',
          sortable: true
        }
      ],
      isFilterOpen: false,
      infiniteId: +new Date(),
      stateOptions: selectVocabulary.stateOptions
    };
  },
  components: {
    Datepicker
  },
  watch: {
    'search.created_at': function(date) {
      if (date) {
        this.search.created_at = moment(date).format('YYYY-MM-DD');
      }

      filterData.apply(this);
    },
    'search.number': filterData,
    'search.filer_name': filterData,
    'search.content_name': filterData,
    'search.url_count': filterData,
    'search.state': filterData
  },
  methods: {
    resetSort() {
      this.sort = [];
      filterData.apply(this);
      this.sortBy = null;
    },

    sortingChanged({ sortBy, sortDesc }) {
      this.sort = _setSortParam(sortBy, sortDesc, this.sort);
      this.sortBy = sortBy;

      filterData.apply(this);
    },

    async infiniteHandler($state) {
      const param = {
        queryString: {
          page: this.page,
          page_size: TABLE_ITEMS_AMOUNT,
          search: this.search,
          sort: this.sort
        }
      };
      const textError = this.$t('commonMessage.requestError');

      try {
        const response = await getData(param);
        this.statementsList = this.statementsList.concat(_restApiDataFormatting(response));

        if (response.data.length) {
          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (error) {
        if (error) {
          this.$rollbar.error(error);
        }
        if (error.data && error.data.detail !== '2FA required') {
          this.$toastr('error', textError, 'Ошибка');
        }
      }
    },

    OnSwitchPage(statementData) {
      this.$router.push({ path: `/statements/${statementData.id}` });
    },
    OnSwitchOnNewPage(statementData) {
      window.open(`/statements/${statementData.id}`, '_blank');
    },
    async toggleFilter() {
      if (!this.isFilterOpen) {
        this.isFilterOpen = true;
        return;
      }

      try {
        await resetData(this.$modal, this.search);
        this.search = {};
        this.isFilterOpen = false;
      } catch (err) {
        // Noop.
      }
    }
  }
};
